import React from 'react';
import { Plus, Radio, Users } from 'lucide-react';

function ClassList({ classes, handleClassClick, handleAddClassClick }) {
  return (
    <section className="bg-[var(--bg-color)] text-[var(--text-color)] px-0 py-2">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
        <button
          id="add-class-btn"
          onClick={handleAddClassClick}
          className="inline-flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold text-white transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] sm:w-auto"
          style={{ backgroundColor: 'var(--primary-color)', boxShadow: 'var(--shadow-primary)' }}
        >
          <Plus size={16} aria-hidden="true" />
          Add Class
        </button>
      </div>
      <div
        id="class-cards"
        className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3"
      >
        {classes.map((classItem) => (
          <div
            key={classItem.classId}
            onClick={() => handleClassClick(classItem.classId)}
            className={`cursor-pointer rounded-lg border p-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md
              ${classItem.hasActiveSession ? 'ring-2 ring-[var(--primary-color)]' : ''}
            `}
            style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-color)', boxShadow: 'var(--shadow-sm)' }}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <h3 className="truncate text-lg font-semibold">{classItem.className}</h3>
                <p className={`mt-2 inline-flex items-center gap-2 text-sm font-medium ${classItem.hasActiveSession ? 'text-[var(--primary-color)]' : 'text-[var(--muted-color)]'}`}>
                  {classItem.hasActiveSession ? <Radio size={15} aria-hidden="true" /> : <Users size={15} aria-hidden="true" />}
                  {classItem.hasActiveSession ? 'Active session' : 'No active session'}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ClassList;
